<template>
  <v-col cols="4" class="agenda-date">
    <p class="agenda-date" v-if="tomorrow">
      AMANHÃ
    </p>

    <p class="agenda-date" v-else="">
      {{ weekday.substring(0, 3) }} <span>{{ dayNumber }}/{{ monthNumber }}</span>
    </p>

    <div
      v-for="(value, name) in agendaHours"
      :key="name"
      v-bind:class="[
        classObj,
        {
          disabled:
            isDayOff || value['availableTimes'].length === 0 ||
            (isHomeSchool ? false : value['availableClassrooms'].length === 0)
        }
      ]"
    >
      <div @click="selectHour(name, value)" class="agenda-time-text">
        {{ name }}h<br>
        <div class='caption'>{{dayOffName}}  </div>
      </div>
    </div>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import weekdays from "@/models/weekdays";
import DayOffRepository from "@/repositories/DayOffRepository";

export default {
  props: {
    day: Object,
    date: Date,
    freeTimes: Array,
    classrooms: Array,
    professorId: [Number, String],
    place: String
  },

  data() {
    return {
      homeSchoolHours: {
        "8": {
          availableTimes: [],
          availableClassrooms: []
        },
        "9": {
          availableTimes: [],
          availableClassrooms: []
        },
        "10": {
          availableTimes: [],
          availableClassrooms: []
        },
        "11": {
          availableTimes: [],
          availableClassrooms: []
        },
        "12": {
          availableTimes: [],
          availableClassrooms: []
        },
        "13": {
          availableTimes: [],
          availableClassrooms: []
        },
        "14": {
          availableTimes: [],
          availableClassrooms: []
        },
        "15": {
          availableTimes: [],
          availableClassrooms: []
        },
        "16": {
          availableTimes: [],
          availableClassrooms: []
        },
        "17": {
          availableTimes: [],
          availableClassrooms: []
        },
        "18": {
          availableTimes: [],
          availableClassrooms: []
        },
        "19": {
          availableTimes: [],
          availableClassrooms: []
        },
        "20": {
          availableTimes: [],
          availableClassrooms: []
        },
        "21": {
          availableTimes: [],
          availableClassrooms: []
        },
      },
      hours: {
        "8": {
          availableTimes: [],
          availableClassrooms: []
        },
        "9": {
          availableTimes: [],
          availableClassrooms: []
        },
        "10": {
          availableTimes: [],
          availableClassrooms: []
        },
        "11": {
          availableTimes: [],
          availableClassrooms: []
        },
        "12": {
          availableTimes: [],
          availableClassrooms: []
        },
        "13": {
          availableTimes: [],
          availableClassrooms: []
        },
        "14": {
          availableTimes: [],
          availableClassrooms: []
        },
        "15": {
          availableTimes: [],
          availableClassrooms: []
        },
        "16": {
          availableTimes: [],
          availableClassrooms: []
        },
        "17": {
          availableTimes: [],
          availableClassrooms: []
        },
        "18": {
          availableTimes: [],
          availableClassrooms: []
        },
        "19": {
          availableTimes: [],
          availableClassrooms: []
        },
        "20": {
          availableTimes: [],
          availableClassrooms: []
        },
        "21": {
          availableTimes: [],
          availableClassrooms: []
        },
      },

      classObj: {
        "agenda-time": true,
        "d-flex": true,
        "align-content-center": true,
        "flex-wrap": true
      },
      isDayOff: false,
      dayOffName: ''
    };
  },

  computed: {
    agendaHours() {
      return this.isHomeSchool ? this.homeSchoolHours : this.hours
    },
    ...mapState(['isHomeSchool']),

    weekday() {
      return weekdays[this.date.getDay()];
    },

    dayNumber() {
      return this.date.getDate();
    },

    monthNumber() {
      return this.date.getMonth() + 1
    },

    tomorrow() {
      return (
        this.date.toDateString() ===
        new Date(new Date().getTime() + 86400000).toDateString()
      );
    },

    parsedDate() {
      return this.date;
    },
  },

  mounted() {
    if (this.freeTimes.length) this.setAvailableTimes();
    if (this.classrooms.length) this.setAvailableClassrooms();
  },

  watch: {
    freeTimes: {
      immediate: true,
      handler() {
        if (this.freeTimes) {
          this.setAvailableTimes();
        }
      }
    },

    classrooms: {
      immediate: true,
      handler() {
        if (this.freeTimes) {
          this.setAvailableClassrooms();
        }
      }
    },

    professorId: {
      immediate: true,
      handler() {
        if (this.freeTimes) {
          this.setAvailableTimes();
          this.setAvailableClassrooms();
        }
      }
    },

    date: {
      immediate: true,
      handler() {
        Object.keys(this.hours).map((objectKey, index) => {
          this.hours[objectKey].availableTimes = [];
        });
        Object.keys(this.homeSchoolHours).map((objectKey, index) => {
          this.homeSchoolHours[objectKey].availableTimes = [];
        });
        if (this.freeTimes) {
          this.setAvailableTimes();
          this.setAvailableClassrooms();
        }
        this.dateIsDayOff()
      }
    }
  },

  methods: {
    setAvailableTimes() {
      var dataset = this.agendaHours
      var date = new Date();
      var currentHour = date.getHours();
      for (var hour in dataset) {
        const timeLimit = this.tomorrow ? parseInt(hour) > currentHour : true;
        dataset[hour]["availableTimes"] = [];

        let tempDate = new Date(this.date)
        tempDate = tempDate.toLocaleDateString('en-US').split('/')
        tempDate = `${tempDate[2]}-${tempDate[0].padStart(2, '0')}-${tempDate[1].padStart(2, '0')}`
        let comparString = `${tempDate}T${String(hour).padStart(2, '0')}`
        let day = this.date.getDay();
        let newfilteredTimes = this.freeTimes.filter(({user_id}) => (this.professorId ? user_id === this.professorId : true))

        const filteredTimes = newfilteredTimes.filter(({ start_at, user_id, week_day, allocated_dates }) => {
          return (
            String(start_at).padStart(2, '0') === String(hour).padStart(2, '0') &&
            day === this.weekdayToInt(week_day) &&
            (this.professorId ? user_id === this.professorId : true) &&
            !allocated_dates.includes(comparString) && timeLimit
          )
        })

        dataset[hour]["availableTimes"] = filteredTimes;
      }
    },

    setAvailableClassrooms() {
      var dataset = this.agendaHours

      for (var hour in dataset) {
        let tempDate = new Date(this.date)
        tempDate = tempDate.toLocaleDateString('en-US').split('/')
        tempDate = `${tempDate[2]}-${tempDate[0].padStart(2, '0')}-${tempDate[1].padStart(2, '0')}`
        let comparString = `${tempDate}T${String(hour).padStart(2, '0')}`
        dataset[hour]["availableClassrooms"] = [];

        this.classrooms.map(classroom => {
          if (!classroom.allocated_dates.includes(comparString))
            dataset[hour]["availableClassrooms"].push(classroom);
        });
      }
    },

    selectHour(name, value) {

      if ( this.dayOffName == '' ) {
        var rand =
          value["availableClassrooms"][
            Math.floor(Math.random() * value["availableClassrooms"].length)
          ];

        value["availableTimes"].length === 0
          ? false
          : this.$emit("selected", {
              hour: name,
              value,
              date: this.date,
              classroom: rand
            });
      } else {
        return
      }
    },

    weekdayToInt(weekday) {
      let day;
      switch (weekday) {
        case "sunday":
          day = 0;
          break;

        case "monday":
          day = 1;
          break;

        case "tuesday":
          day = 2;
          break;

        case "wednesday":
          day = 3;
          break;

        case "thursday":
          day = 4;
          break;

        case "friday":
          day = 5;
          break;

        case "saturday":
          day = 6;
          break;

        default:
          break;
      }
      return day;
    },

    async dateIsDayOff() {
      let response = await DayOffRepository.isDayOff( this.place, this.date )
      this.isDayOff = response.data.is_day_off
      this.dayOffName = response.data.is_day_off ? response.data.day_off.description : ''
    }
  }
};
</script>

<style>
.agenda-date {
  max-width: 150px;
}
p.agenda-date {
  color: #44ff99;
  font-size: 21px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
}
.agenda-date span {
  font-weight: 400;
  font-style: italic;
  color: #ffffff;
}
.agenda-time {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 70px;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 2px 1px;
  background: rgba(255, 255, 255, 0.4);
  background: -moz-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(255, 255, 255, 0.4)),
    color-stop(100%, rgba(255, 255, 255, 0.5))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=1 );
}
.agenda-time:hover {
  background: rgba(255, 255, 255, 0.6);
  background: -moz-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(255, 255, 255, 0.6)),
    color-stop(100%, rgba(255, 255, 255, 0.7))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=1 );
}
.agenda-time:active {
  background: rgba(68, 255, 153, 0.9);
}
.agenda-time.disabled {
  background: rgba(120, 120, 120, 0.5);
}
.agenda-time-text {
  width: 100%;
  text-align: center;
  font-size: 21px;
  font-weight: 400;
  color: #ffffff;
}
.agenda-time.disabled div.agenda-time-text {
  color: rgba(50, 50, 50, 0.5);
}
</style>
